import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import i18next from 'i18next'

// S10-17: Search schema for timespan picker
// i18n-Fix (i18n100-5): Zod-Message war hartkodiert Englisch. `main.tsx` importiert
// './i18n' vor './routeTree.gen' (und damit vor dieser Route-Datei) — i18next ist beim
// Modul-Laden dieser Datei bereits synchron initialisiert (siehe src/i18n/index.ts,
// resources werden ohne async Backend eager geladen).
const invalidDateFormatMessage = i18next.t('common:validation.invalidDateFormat')
// R5 / Stream TD: `?tag=<id>` scoped das Dashboard auf einen Tag — exakt die
// v1-URL (dashboard_path(tag: tag.id), views/tags/_tag.haml:8-13). Bewusst
// KEINE eigene Route /tags/:id/dashboard: gleiches Layout, gleiche Widgets,
// nur ein anderer Scope (R5-Entscheidung TD).
const timespanSearchSchema = z.object({
  // FE-ROB-06: .catch(undefined) — ein unsinniger Datums-/Tag-Param (z. B.
  // ?from=2026-1-1 aus einem alten Link) darf nicht die komplette Seite durch
  // die Root-Fehlerseite ersetzen, sondern faellt auf "kein Filter" zurueck.
  from: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, invalidDateFormatMessage).optional().catch(undefined),
  to: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, invalidDateFormatMessage).optional().catch(undefined),
  tag: z.coerce.number().int().positive().optional().catch(undefined),
})

export const Route = createFileRoute('/_auth/dashboard')({
  validateSearch: timespanSearchSchema,
})
